import script from "./AppResizableDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppResizableDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./AppResizableDropdown.vue?vue&type=style&index=0&id=0b78d646&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b78d646"]])

export default __exports__